export default __webpack_public_path__ + "assets/spinner-component.4e97f558.svg";